import builder from '../builder';
import RemoveCircle from '../../streamline-icons/light/remove-circle.svg';

export default builder('IconRemoveCircleLight', RemoveCircle);
